export const getAbsenceTypes = (state) => state.types